import { action } from 'typesafe-actions'

import { RequestItinerary, Timestamp } from 'src/types'

import { MyTeamActionTypes } from './types'

interface Filters {
  ended_on: Timestamp
  started_on: Timestamp
}

interface Options {
  filters: Filters
}

export const getMyTeam = (options: Options) =>
  action(MyTeamActionTypes.GET_MY_TEAM, { options })

export const getMyTeamSuccess = (list: RequestItinerary[]) =>
  action(MyTeamActionTypes.GET_MY_TEAM_SUCCESS, { list })

export const getMyTeamFailure = () =>
  action(MyTeamActionTypes.GET_MY_TEAM_FAILURE)
